<template>
  <div>
    <div v-if="isFilterApplied" class="d-flex justify-content-end mb-3">
      <a
        href="javascript:;"
        class="btn btn-secondary w-60 display-6"
        @click="handleClearFilters"
      >
        Clear Filters
      </a>
    </div>
  </div>
  <form @submit.prevent="handleFilters">
    <div class="row filter-row">
      <div v-if="!hideJob" class="col-sm-6 col-md-2 position-relative">
        <div class="input-block mb-3 form-focus select-focus">
          <vue-select
            :options="jobs"
            v-model="filters.job_id"
            placeholder="Select Job Title"
            id="design3"
          />
          <label class="focus-label">Job Title</label>
        </div>
        <i
          v-if="filters.job_id"
          @click="handleClearOneFilter('job_id')"
          class="fa-solid fa-x"
          :style="{
            position: 'absolute',
            top: '-20px',
            right: '0px',
            cursor: 'pointer',
          }"
        ></i>
      </div>
      <div v-if="!hideDept" class="col-sm-6 col-md-2 position-relative">
        <div class="input-block mb-3 form-focus select-focus">
          <vue-select
            :options="departments"
            v-model="filters.departmentName"
            placeholder="Select Department"
            id="design2"
          />
          <label class="focus-label">Department</label>
        </div>
        <i
          v-if="filters.departmentName"
          @click="handleClearOneFilter('departmentName')"
          class="fa-solid fa-x"
          :style="{
            position: 'absolute',
            top: '-20px',
            right: '0px',
            cursor: 'pointer',
          }"
        ></i>
      </div>
      <div v-if="!hideTest" class="col-sm-6 col-md-2 position-relative">
        <div class="input-block mb-3 form-focus select-focus text-truncate">
          <vue-select
            :options="tests"
            v-model="filters.test_name"
            placeholder="Select Test Title"
            id="design4"
          />
          <label class="focus-label">Test Title</label>
        </div>
        <i
          v-if="filters.test_name"
          @click="handleClearOneFilter('test_name')"
          class="fa-solid fa-x"
          :style="{
            position: 'absolute',
            top: '-20px',
            right: '0px',
            cursor: 'pointer',
          }"
        ></i>
      </div>

      <div class="col-md-9"></div>
      
      <div class="d-flex mb-2 col-sm-6 col-md-3 gap-2">
        <button
          type="submit"
          href="javascript:;"
          class="btn btn-success w-100"
          @click.prevent="handleFilters"
        >
          Search
        </button>
        <button
          type="button"
          href="javascript:;"
          class="btn btn-success w-100"
          @click.prevent="resetAllFilters"
        >
          Reset
        </button>
      </div>
    </div>
  </form>
</template>

<script>
import DepartmentService from "@/services/DepartmentService";
import RecruitmentRequisitionService from "@/services/RecruitmentRequisitionService";
import AptitudeTestService from "@/services/AptitudeTestService";
import { bool } from "yup";

export default {
  data() {
    return {
      select2: null,
      isFocused: false,
      filters: {
        departmentName: "",
        job_id: "",
        test_name: "",
      },
      isFocusedOn: false,
      departments: [],
      tests: [],
      jobs: [],
      searched: false,
    };
  },
  props: {
    hideJob: {
      default: false,
      type: bool
    },
    hideDept: {
      default: false,
      type: bool
    },
    hideTest: {
      default: false,
      type: bool
    },
  },
  methods: {
    handleFilters(value) {
      this.searched = true;
      this.$emit("apply-filters", this.filters);
    },
    handleClearOneFilter(fileName) {
      this.filters[fileName] = "";
      const filtersHasProperty = Object.values(this.filters).filter(
        (el) => !!el
      ).length;
      if (this.searched) {
        this.$emit("apply-filters", this.filters);
      }
      if (!filtersHasProperty) {
        this.searched = false;
      }
    },
    resetAllFilters() {
      // Reset all filter values to empty strings
      Object.keys(this.filters).forEach((key) => {
        this.filters[key] = "";
      });
      // Emit updated filters
      this.$emit("apply-filters", this.filters);
      // Reset search state
      this.searched = false;
    },
    async fetchTests() {
      try {
        const response = await AptitudeTestService.fetch();
        this.tests = response?.data.map((el) => el.test_name);
      } catch (error) {
        console.error("Error fetching tests:", error);
      }
    },
    async fetchJobs() {
      try {
        const response = await RecruitmentRequisitionService.fetch();
        this.jobs = response?.data.map((el) => el.job_title);
      } catch (error) {
        console.error("Error fetching jobs:", error);
      }
    },
    async fetchDepts() {
      try {
        const response = await DepartmentService.getDepartments();
        this.departments = response?.data.map((el) => el.name);
      } catch (error) {
        console.error("Error fetching departments:", error);
      }
    },
    handleClearFilters() {
      this.$emit("apply-filters", {});
      this.filters = {
        departmentName: "",
        job_id: "",
        test_name: "",
      };
      this.searched = false;
    },
    async fetchServices() {
      try {
        !this.hideTest && this.fetchTests();
        !this.hideJob && this.fetchJobs();
        !this.hideDept && this.fetchDepts();
      } catch (error) {
        console.log("error fetching services", error);
      }
    },
  },
  created() {
    this.searched = false;
    this.fetchServices();
  },
  computed: {
    isFilterApplied() {
      const filtersHasProperty = Object.values(this.filters).filter(
        (el) => !!el
      ).length;

      return this.searched && filtersHasProperty;
    },
  },
};
</script>
